import kabadaAPI from './kabadaAPI';
import { errorHandler } from './errorHandler';

export const getCashFlow = (planId) => {
    return async (dispatch, getState) => {
        dispatch({ type: "LOADING", payload: true });
        dispatch({ type: 'RESET_CASH_FLOW' })
        try {
            const token = getState().user.access_token;
            const response = await kabadaAPI.get('api/plans/cashflow/' + planId, { headers: { Authorization: `Bearer ${token}` } });
            dispatch({ type: "FETCHING_CASHFLOW_SUCCESS", payload: response.data });
        } catch (error) {
            if (error.response === undefined) {
                dispatch({
                    type: "ERROR",
                    payload: { message: "Oopsie... System error. Try again, later" },
                });
            } else {
                dispatch({ type: "ERROR", payload: error.response.data });
            }
        } finally {
            dispatch({ type: "LOADING", payload: false });
        }
    };
};